module.exports = __webpack_public_path__ + "media/footer/getIOSApp-73d48697.svg";